import { Outlet } from "react-router-dom";

const CSR = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default CSR;
